import React from 'react';
import AdImg from '../constants/img/AdImg.svg'
const Ad = () => {
    return (
        <>
            <img src={AdImg} alt="광고" width={`100%`}/>
        </>
    );
};

export default Ad;